import { render } from "./OrganisationGoodieEdit.vue?vue&type=template&id=4adf2682"
import script from "./OrganisationGoodieEdit.vue?vue&type=script&lang=js"
export * from "./OrganisationGoodieEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__